import request from '@/utils/request'

// 获取微信code
export function getCode(data) {
  return request({
    url: 'wechat/Base/WxUserAuthorize',
    method: 'get',
    params: data
  })
}

// 获取openid/token
export function getToken(data) {
  return request({
    url: 'wechat/Base/WxUserInfo',
    method: 'get',
    params: data
  })
}

// 面试时间段列表
export function interviewerTimes(data) {
  return request({
    url: 'index/interview/interviewerTimes',
    method: 'get',
    params: data
  })
}

// 用户预约
export function interviewAdd(data) {
  return request({
    url: 'index/interview/interviewAdd',
    method: 'post',
    data: data
  })
}

// 预约记录
export function interviewRecord(data) {
  return request({
    url: 'index/interview/interviewRecord',
    method: 'post',
    data: data
  })
}
